import { api } from '../api';

export const getTokenSheet = async () => {
  const { data } = await api.get('/sheets/token');

  return data;
};
